import ModelMenu from "@/components/creator/music/ModelMenu";
import { BASE_MODELS } from "@/lib/sunoVoicesApi";

const chip = (on) => `rounded-full border px-3 py-1 text-[12px] transition-colors duration-200 ${on ? "border-cyan-300/70 bg-cyan-300/20 font-semibold text-white" : "border-white/10 bg-white/[0.03] text-white/60 hover:bg-white/[0.08]"}`;

/** "Model" row in Music settings: the menu, plus which V6 model your voice sings on. */
export default function ModelRow({ form, sunoVoices, oldVoices, onChange }) {
  const eng = { model: "V6", custom_model_id: null, ...(form.engine || {}) };
  const voiceOn = Boolean(eng.custom_model_id) || (form.vocal.mode === "signature" && form.vocal.source === "my_voice");
  return (
    <div data-testid="model-row">
      <p className="font-mono text-[11px] uppercase tracking-[0.16em] text-white/70">Model</p>
      <div className="mt-2"><ModelMenu engine={eng} vocal={form.vocal} sunoVoices={sunoVoices} oldVoices={oldVoices} onChange={onChange} /></div>
      {voiceOn ? (
        <div className="mt-2.5 flex flex-wrap items-center gap-1.5">
          <span className="mr-1 font-mono text-[10px] uppercase tracking-[0.16em] text-white/45">Sings on</span>
          {BASE_MODELS.map((m) => <button key={m.id} type="button" data-testid={`model-base-chip-${m.id}`} aria-pressed={eng.model === m.id} className={chip(eng.model === m.id)} onClick={() => onChange({ engine: { ...eng, model: m.id } })}>{m.label}</button>)}
        </div>
      ) : null}
      {eng.custom_model_id && form.vocal.mode === "instrumental" ? <p data-testid="model-instrumental-note" className="mt-2 text-[11px] text-amber-200/80">Instrumental songs have no singer — your voice isn't used.</p> : null}
    </div>
  );
}
